import { ChartDataset } from 'chart.js';

import { CanvasComponentOptions } from '@shared/components/canvas-chart/canvas-chart.component';
import { CustomType } from '@shared/services/gql.service';
import { Utils } from '@shared/utils/utils';

import { Distribution } from '../custom-drivers.component';

export const DistributionType = {
  '%': 'Percentage (%)',
  Dollars: 'Dollars',
  Units: 'Units',
};

export const CustomDriverType = {
  [DistributionType.Dollars]: CustomType.CUSTOM_GROUP_DOLLARS,
  [DistributionType.Units]: CustomType.CUSTOM_GROUP_UNITS,
  [DistributionType['%']]: CustomType.CUSTOM_GROUP_PERCENTAGE,
} as const;

export class CustomCurvesConstants {
  // eslint-disable-next-line max-lines-per-function
  static multiChartOptions(
    unit: string,
    data: Distribution[],
    labels: string[]
  ): CanvasComponentOptions {
    const colors = [
      {
        border: false,
        color: '#095b95',
      },
      {
        border: true,
        color: '#236262',
      },
    ].map(({ border, color }) => {
      return <ChartDataset<'line'>>{
        backgroundColor: color,
        borderColor: color,
        borderWidth: border ? 3 : 0,
        hoverBackgroundColor: color,
        hoverBorderColor: color,
        pointBackgroundColor: color,
        pointBorderColor: color,
        pointHitRadius: 4,
        pointHoverBackgroundColor: color,
        pointHoverBorderColor: color,
        pointHoverBorderWidth: 4,
        pointHoverRadius: 4,
        pointRadius: 0,
        pointStyle: 'rectRounded',
      };
    });
    const lineData = data.every((distribution) => distribution.custom_amount == 0)
      ? []
      : data.reduce((acc: number[], el: Distribution, index: number) => {
          acc.push(
            index ? Number(el.custom_amount) + acc[index - 1] : Number(el.custom_amount) || 0
          );

          return acc;
        }, []);

    return {
      data: {
        datasets: [
          {
            ...colors[0],
            data: data.map((x) => x.custom_amount || 0),
            label: `Planned ${unit}`,
            // https://github.com/chartjs/Chart.js/issues/11356
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            type: 'bar',
          },
          {
            ...colors[1],
            data: lineData,
            label: `Cumulative ${unit}`,
            type: 'line',
          },
        ],
        labels,
      },
      legend: { bottom: true, left: false, right: false, top: false },
      options: {
        maintainAspectRatio: false,
        plugins: {
          tooltip: {
            callbacks: {
              label(tooltipItem): string | string[] | void {
                const value = Number(tooltipItem.raw) || 0;

                return `${tooltipItem.datasetIndex === 0 ? 'Planned Monthly' : 'Cumulative'} ${unit}: ${value.toLocaleString(
                  'en-US',
                  {
                    maximumFractionDigits: 2,
                    minimumFractionDigits: 2,
                  }
                )}${unit === '%' ? '%' : ''}`;
              },
            },
          },
        },
        scales: {
          y: {
            ticks: {
              callback: (value) => (lineData.length || !value ? value : Utils.zeroHyphen),
            },
          },
        },
      },
      type: 'line',
    };
  }
}
